import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className='w-full text-gray-800 dark:text-gray-300 py-24 px-4 bg-white dark:bg-[#0a1220] transition-colors duration-300'>
            <div className='max-w-[1000px] mx-auto'>
                <h1 className='text-4xl font-bold mb-8 text-secondary'>Privacy Policy</h1>

                <p className='mb-4 text-sm text-gray-500'>Last updated: {new Date().toLocaleDateString()}</p>

                <section className='mb-8'>
                    <h2 className='text-2xl font-semibold mb-4 text-gray-900 dark:text-white'>1. Introduction</h2>
                    <p className='mb-4'>
                        Welcome to DataHelix ("we," "our," or "us"). We respect your privacy and are committed to protecting your personal data.
                        This privacy policy will inform you as to how we look after your personal data when you visit our website (regardless of where you visit it from)
                        and tell you about your privacy rights and how the law protects you.
                    </p>
                </section>

                <section className='mb-8'>
                    <h2 className='text-2xl font-semibold mb-4 text-gray-900 dark:text-white'>2. Data We Collect</h2>
                    <p className='mb-4'>
                        We may collect, use, store and transfer different kinds of personal data about you which we have grouped together follows:
                    </p>
                    <ul className='list-disc pl-6 space-y-2'>
                        <li><strong>Identity Data:</strong> includes first name, last name, username or similar identifier.</li>
                        <li><strong>Contact Data:</strong> includes email address.</li>
                        <li><strong>Usage Data:</strong> includes information about how you use our website, products and services (e.g., progress in SQL cases).</li>
                    </ul>
                </section>

                <section className='mb-8'>
                    <h2 className='text-2xl font-semibold mb-4 text-gray-900 dark:text-white'>3. How We Use Your Data</h2>
                    <p className='mb-4'>
                        We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
                    </p>
                    <ul className='list-disc pl-6 space-y-2'>
                        <li>Where we need to perform the contract we are about to enter into or have entered into with you (e.g., tracking your course progress).</li>
                        <li>Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.</li>
                    </ul>
                </section>

                <section className='mb-8'>
                    <h2 className='text-2xl font-semibold mb-4 text-gray-900 dark:text-white'>4. Data Security</h2>
                    <p className='mb-4'>
                        We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed.
                    </p>
                </section>

                <section className='mb-8'>
                    <h2 className='text-2xl font-semibold mb-4 text-gray-900 dark:text-white'>5. Contact Us</h2>
                    <p className='mb-4'>
                        If you have any questions about this privacy policy or our privacy practices, please contact us at: <a href="mailto:support@datahelix.io" className='text-accent hover:underline'>support@datahelix.io</a>
                    </p>
                </section>

            </div>
        </div>
    );
};

export default PrivacyPolicy;
